import { render, staticRenderFns } from "./otherMatters.vue?vue&type=template&id=4cb8b5d4&"
import script from "./otherMatters.vue?vue&type=script&lang=js&"
export * from "./otherMatters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports